module.exports = __webpack_public_path__ + "static/img/6en.0c97ae7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/huawei/6en.png
// module id = NdMJ
// module chunks = 0